export interface CustomFieldFrontendSelectableOption {
  displayValue: string;
  id: number;
  value: string;
}

export type SelectFieldPluginSingleValuedFrontendValue = CustomFieldFrontendSelectableOption | null;

export const INACTIVE_SELECTABLE_OPTION_ID = -1;
